export const getEntryUrl = ({ entryId, spaceId }: {
  entryId: string,
  spaceId: string
}) => {
  return `https://app.contentful.com/spaces/${spaceId}/entries/${entryId}`;
};
